<template>
    <record-item
        v-bind:recordData="source"
        v-bind:itemFunc="clickFamousChooseRecordItem">
    </record-item>
</template>

<script>
import RecordItem from '../record/RecordItem.vue'
import { CONFIG } from '../../modules/config';
export default {
    name: 'FamousChooseRecordItem',
    components: { RecordItem },
    props: {
        source: {   
            type: Object,
            default () { return {} }
        }
    },
    methods: {
        clickFamousChooseRecordItem(recordData) {
            var me = this,
                originalData = this.$store.state.record.recordOriginalData,
                itemData = originalData[recordData.id];
            this.$store.dispatch('famouspedia/addBaike', {
                data: itemData,
                cb: function() {
                    me.$toast('创建百科草稿成功，可在[我的百科]中查看');
                    setTimeout(() => {
                        if(CONFIG.platform == 'web') {
                            me.$router.replace('/famouspediaeditweb/list');
                        }else {
                            me.$router.replace('/famouspediaedit');
                        }
                    }, 100);
                    // 清空搜索数据
                    me.$store.dispatch('search/resetData');
                }
            });
        }
    }
}
</script>